module.exports = __webpack_public_path__ + "static/media/boom.61ac99cb.ogg";